function check($inputCheckBox) {
	if (!$inputCheckBox) {
		return;
	}

	const $input = $inputCheckBox.tagName.toLowerCase() === "input" ? $inputCheckBox : $inputCheckBox.querySelector("input");

	$input.checked = "checked";
	$input.parentElement.classList.add("checked");
}

function unCheck($input) {
	$input.checked = "";
	$input.parentElement.classList.remove("checked");
}

function styleCheckBoxes($checkBoxes) {
	if (!$checkBoxes) {
		return;
	}

	$checkBoxes.forEach(($checkBox) => {
		styleCheckBox($checkBox);
	});
}

function styleCheckBox($checkBox) {
	const $checkBoxContainer = $checkBox.parentElement;
	const $insertBefore = $checkBoxContainer.querySelector("label");
	const $wrapperDiv = document.createElement("div");

	$wrapperDiv.className = "styledCheckbox";
	$wrapperDiv.tabIndex = "0";
	$wrapperDiv.role = "checkbox";

	$checkBox.classList.add("hidden");

	$wrapperDiv.appendChild($checkBox);
	$checkBoxContainer.insertBefore($wrapperDiv, $insertBefore);

	$wrapperDiv.addEventListener("click", (evt) => {
		const $input = evt.currentTarget.querySelector("input");
		if ($input.checked) {
			unCheck($input);
		} else {
			check($input);
		}
	});
}

export { check, unCheck, styleCheckBoxes, styleCheckBox };
